import {
  TTranslationEvent,
} from '@/components/item-notification/item-notification.ts';

const event: TTranslationEvent = {
  job_finished: {
    label: '{assetDisplayName}: Job {displayName} is finished',
    description: 'Job {displayName} with recipe: {recipeDisplayName} is finished at {finishedAtUtc} on {assetDisplayName} in {locationDisplayName}.\nJob description: {description}',
  },
  job_started: {
    label: '{assetDisplayName}: New job {displayName} has been started',
    description: 'Job {displayName} with recipe: {startedAtUtc} is finished at {finishedAtUtc} on {assetDisplayName} in {locationDisplayName}.\nJob description: {description}',
  },
  timeseries_lag_detected: {
    label: '{assetDisplayName}: Timeseries lag detected',
    description: 'Timeseries lag detected on {assetDisplayName} in {locationDisplayName}',
  },
  alarm_occurred: {
    label: '{assetDisplayName}: {severityTranslation} {alarmDisplayName}',
    description: '{severityTranslation} \'{alarmDisplayName}\' detected on {assetDisplayName} in {locationDisplayName}',
  },
  new_qmulus_release: {
    label: 'New Qmulus version',
    description: 'Qmulus v{version} has just been released. See the release notes to learn more',
  },
  control_level_exceeded: {
    label: 'Control Level Exceeded',
    description: 'Control level of the sensor readings exceeded',
  },
  drift_detected: {
    label: 'Drift Detected',
    description: 'Sensor readings are drifting from the reference values',
  },
  trend_detected: {
    label: 'Trend Detected',
    description: 'Qmulus detected a new trend in sensor readings',
  },
  maintenance_occurrence_state_changed: {
    label: 'Maintenance State Changed',
    description: '\'{seriesDisplayName}\' maintenance on {assetDisplayName} status has been changed to {maintenanceStateTranslation}.',
  },
};

export default {
  markAsRead: 'Mark as read',
  goToEvent: 'Go to Event',
  event,
  timeseriesLagStopped: {
    label: '{assetDisplayName}: Timeseries lag stopped',
    description: 'Timeseries lag on {assetDisplayName} in {locationDisplayName} has stopped',
  },
};
